import { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";

export default function TinyEditor({ change, data }) {
  const editorRef = useRef(null);

  return (
    <>
      <Editor
        apiKey="eagdmk4qmrfjq3ri81l2qav54r0ddbb6c2sbaajtu6zx6w7i"
        onInit={(_evt, editor) => (editorRef.current = editor)}
        initialValue={data}
        init={{
          selector: data,

          height: 500,
          menubar: false,

          plugins:
            "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion",
          toolbar:
            "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
        onChange={(e) => {
          change(e.target.getContent());
        }}
      />
    </>
  );
}
